import {time} from '../ladmin/utils'

const placeholder = 'N/A'

const actionHeader = {text: '', value: '', align: 'right', width: '80px', sortable: false}
export const ADMIN_HEADERS = [
  {text: '车辆号牌', value: 'plate', align: 'left', placeholder},
  {text: '访客手机', value: 'phone', align: 'right', placeholder, sortable: false},
  {text: '访客姓名', value: 'name', align: 'right', placeholder, sortable: false},
  {text: '开始时间', value: 'startDatetime', align: 'right', placeholder, f: v => time.stringify(v)},
  {text: '结束时间', value: 'endDatetime', align: 'right', placeholder, f: v => time.stringify(v)},
  {text: '是否有效', value: 'status', align: 'left', placeholder, f: (v) => (v === '1' ? '有效' : '失效')},
]
export const PERSON_ADMIN_HEADERS = [
  {text: '通行对象', value: 'plate', align: 'left', placeholder},
  {text: '访客手机', value: 'phone', align: 'right', placeholder, sortable: false},
  {text: '访客姓名', value: 'name', align: 'right', placeholder, sortable: false},
  {text: '开始时间', value: 'startDatetime', align: 'right', placeholder, f: v => time.stringify(v)},
  {text: '结束时间', value: 'endDatetime', align: 'right', placeholder, f: v => time.stringify(v)},
  {text: '是否有效', value: 'status', align: 'left', placeholder, f: (v) => (v === '1' ? '有效' : '失效')},
]
export const VEHICLE_HEADERS = [
  {text: '车辆号牌', value: 'plate', align: 'left', placeholder},
  {text: '车主姓名', value: 'name', align: 'right', placeholder},
  {text: '车主电话', value: 'phone', align: 'right', placeholder},
  {text: '所在单位', value: 'orgName', align: 'right', placeholder},
]

export const TYPE_TEXT = {
  order_object: '个人预约',
  order_group: '单位预约',
  admin: '高级预约',
  order_business: '函件预约'
}
export const GROUP_HEADERS = [
  {text: '分组名称', value: 'name', align: 'left', placeholder},
  {text: '车辆号牌', value: 'platePreview', align: 'left', placeholder, maxWidth: '6em', tooltip: true, sortable: false},
  {text: '车辆总数', value: 'total', align: 'left', placeholder, sortable: false},
  {text: '联系人', value: 'host', align: 'left', placeholder, sortable: false},
  {text: '联系电话', value: 'phone', align: 'left', placeholder, sortable: false},
  {text: '创建时间', value: 'creationTime', align: 'left', placeholder, f: v => time.stringify(v)},
  {text: '过期时间', value: 'expirationTime', align: 'left', placeholder},
]
export const GROUP_RESERVATION_HEADERS = [
  {text: '分组名称', value: 'name', align: 'left', placeholder},
  {text: '车辆号牌', value: 'platePreview', align: 'left', placeholder, maxWidth: '6em', tooltip: true, sortable: false},
  {text: '车辆总数', value: 'total', align: 'left', placeholder, sortable: false},
  {text: '联系人', value: 'host', align: 'left', placeholder, sortable: false},
  {text: '联系电话', value: 'phone', align: 'left', placeholder, sortable: false},
  {text: '过期时间', value: 'expirationTime', align: 'left', placeholder,f: v => time.stringify(v)},
]
export const PERSON_GROUP_RESERVATION_HEADERS = [
  {text: '分组名称', value: 'name', align: 'left', placeholder},
  {text: '通行对象', value: 'platePreview', align: 'left', placeholder, maxWidth: '6em', tooltip: true, sortable: false},
  {text: '行人总数', value: 'total', align: 'left', placeholder, sortable: false},
  {text: '联系人', value: 'host', align: 'left', placeholder, sortable: false},
  {text: '联系电话', value: 'phone', align: 'left', placeholder, sortable: false},
  {text: '过期时间', value: 'expirationTime', align: 'left', placeholder,f: v => time.stringify(v)},
  {text: '创建时间', value: 'creationTime', align: 'left', placeholder,f: v => time.stringify(v)},
]
export const ADMIN_ACTION_HEADERS = [
  ...ADMIN_HEADERS,
  actionHeader,
]
export const PERSON_ADMIN_ACTION_HEADERS = [
  ...PERSON_ADMIN_HEADERS,
  actionHeader,
]
export const GROUP_ACTION_HEADERS = [
  ...GROUP_RESERVATION_HEADERS,
  {text: '是否有效', value: 'status', align: 'left', placeholder, f: (v) => (v === '1' ? '有效' : '失效')},
  actionHeader,
]
export const PERSON_GROUP_ACTION_HEADERS = [
  ...PERSON_GROUP_RESERVATION_HEADERS,
  {text: '是否有效', value: 'status', align: 'left', placeholder, f: (v) => (v === '1' ? '有效' : '失效')},
  actionHeader,
]
export const GROUP_VEHICLE_HEADER = [
  ...ADMIN_HEADERS,
  actionHeader,
]
export const PERSONAL_RESERVATION_HEADER = [
  ...ADMIN_HEADERS,
  actionHeader,
]

export const VEHICLE_ACTION_HEADERS = [
  ...VEHICLE_HEADERS,
  actionHeader,
]

export const ID_TYPE_REVERSE = {
  '护照': 'passport',
  '军官证': 'osCard',
  '警官证': 'osCard',
  '士兵证': 'osCard',
  '港澳居民来往内地通行证': 'mtPermit',
  '台湾居民来往内地通行证': 'mtPermit',
  '居民身份证': 'idCard',
  '身份证': 'idCard',
  '港澳|台湾居民来往内地通行证': 'mtPermit',
  '军官证|警官证|士兵证': 'osCard',
  '学生证': 'stdCard',
}
export const ID_TYPE_TEXT = {
  'passport': '护照',
  'idCard': '居民身份证',
  'mtPermit': '港澳|台湾居民来往内地通行证',
  'osCard': '军官证|警官证|士兵证',
  'stdCard': '学生证',
}
